import { Text } from "@towersystems/roam-common-native";
import { Spacings, View } from "react-native-ui-lib";
import { toTitleCase } from "../../../../../../../utilities/to-title-case";
import { CartItemProps } from "../types";

export type CartItemProductDetailsProps = Pick<
  CartItemProps,
  "item" | "product"
> & {
  tintColor: string;
};

export function CartItemProductDetails({
  tintColor,
  item,
  product,
}: CartItemProductDetailsProps) {
  return (
    <View
      style={{
        flexBasis: "100%",
        flexShrink: 1,
        paddingRight: Spacings.s4,
      }}
    >
      <Text
        style={{
          fontSize: 17,
          fontWeight: "bold",
          color: tintColor,
        }}
        ellipsizeMode="head"
        numberOfLines={1}
      >
        {toTitleCase(item.name ?? product.name)}
      </Text>
      {product.displayName ? (
        <Text color="subdued" variant="heading5">
          {product.displayName}
        </Text>
      ) : undefined}

      <Text color="subdued" variant="heading5">
        {item?.stockNumber ?? product.stockNumber}
      </Text>

      {item.giftCardNumber ? (
        <Text numberOfLines={4} color="subdued">
          {`Gift card number: ${item.giftCardNumber}`}
        </Text>
      ) : null}
      {product.deletedAt ? (
        <Text color="destructive" variant="heading5">
          {`WARNING: This product has been deleted.`}
        </Text>
      ) : undefined}
      {item.metadata?.surcharge === true ? (
        <Text color="subdued">{item.metadata?.surchargeDescription}</Text>
      ) : null}
      {item.serialNumber ? (
        <Text color="subdued">S/N: {item.serialNumber}</Text>
      ) : null}
      {item.customerNote ? (
        <Text numberOfLines={4} color="subdued">
          {`"${item.customerNote}"`}
        </Text>
      ) : null}
    </View>
  );
}
